module.exports = __webpack_public_path__ + "static/online-program-01-78a77be3a22b76bad697ebc740ba224f.jpg";